import React, { type PropsWithChildren } from "react";
import useWindowSize from "../../../../utility/useWindowSize";

interface ScalerProps {
    minScale?: number;
    maxScale?: number;
    baseWidth?: number;
}

const Scaler = ({
    minScale = 0.5,
    maxScale = 1,
    baseWidth = 1920,
    children
}: PropsWithChildren<ScalerProps>) => {
    const windowSize = useWindowSize();

    let factor = windowSize.width / baseWidth;

    if (factor > maxScale) {
        factor = maxScale;
    }

    if (factor < minScale) {
        factor = minScale;
    }

    return <div style={{ zoom: factor }}>
        {children}
    </div>;
};

export default Scaler;